import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";
import {
  ENABLE_DISABLE_USER_MANAGEMENT,
  GET_ALL_SUB_USER,
  GET_ALL_USER,
} from "../../../utils/constant";

import { getTokenFromLocalStorage } from "../../../utils/tokenService";
import { jwtDecode } from "jwt-decode";
import ViewUser from "./ViewUser";
import EditUser from "./EditUser";
import { useSelector } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useApiServices from "../../../utils/useApiServices";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import CreateUser from "./CreateUser";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import CustomTip from "../../../common/CustomTip";
import { ToolsActionRegistry } from "../../../Privillages/ActionRegistry";
import useHasPrivilege from "../../../Privillages/useHasPrivilege";

const SubmittedUser = ({ toggleRightBar, type1 }) => {
  const { TOOLS_USER_KEY, USER_CREATE, USER_EDIT } = ToolsActionRegistry;
  const hasUserCreate = useHasPrivilege(TOOLS_USER_KEY, USER_CREATE);
  const hasUserEdit = useHasPrivilege(TOOLS_USER_KEY, USER_EDIT);
  const [submittedUser, setSubmittedUser] = useState([]);
  const [callAgain, setCallAgain] = useState(false);
  const [id, setId] = useState("");
  const [selectedAction, setSelectedAction] = useState("");
  const [show, setShow] = useState(false);
  const [show3, setShow3] = useState(false);
  const token = getTokenFromLocalStorage();
  const [isModalRoutingOpen, setIsModalRoutingOpen] = useState(false);
  const decodedToken = typeof token === "string" ? jwtDecode(token) : {};
  const { masterId } = decodedToken;
  const { prefix, type } = useSelector((state) => state.userPrivileges);
  const { apiCallFnforPut, apiCallFnforGet } = useApiServices();

  const columns = [
    { headerName: "Name", field: "name", minWidth: "170" },
    { headerName: "Email", field: "email", minWidth: "190" },
    { headerName: "Mobile Number", field: "mobile", minWidth: "150" },
    { headerName: "Status", field: "status", minWidth: "150" },
    { headerName: "Action", field: "action", minWidth: "150" },
  ];

  const handleAction = (item, action) => {
    switch (action) {
      case "view":
        View(item.aggrigatorSubUserId);
        break;
      case "edit":
        Edit(item.aggrigatorSubUserId);
        break;
      case "enable":
        if (!item.active) {
          disableAggregator(
            item?.aggrigatorSubUserId,
            item?.masterMerchantId,
            "enable"
          );
        }
        break;
      case "disable":
        if (item.active) {
          disableAggregator(
            item?.aggrigatorSubUserId,
            item?.masterMerchantId,
            "disable"
          );
        }
        break;
      default:
        break;
    }
  };

  const getAll = async () => {
    try {
      const response = await apiCallFnforGet(GET_ALL_USER + masterId);

      if (response.statusCode === 200) {
        const finalRes = response?.data?.map((item, i) => ({
          id: i,
          name: item?.name,
          email: item?.email,
          mobile: item?.mobile,
          status: item?.active ? "Enable" : "Disable",
          action: (
            <Select
              value={selectedAction}
              onChange={(e) => {
                setSelectedAction(e?.target?.value);
                handleAction(item, e?.target?.value);
              }}
              displayEmpty
              sx={{
                width: 40,
                backgroundColor: "#A3C8ED",
                borderRadius: 8,
                padding: "8px 2px",
                height: "25px",
              }}
            >
              <MenuItem value="view">View</MenuItem>
              {hasUserEdit && <MenuItem value="edit">Edit</MenuItem>}
              {hasUserEdit &&
                (item.active ? (
                  <MenuItem value="disable">Disable</MenuItem>
                ) : (
                  <MenuItem value="enable">Enable</MenuItem>
                ))}
            </Select>
          ),
        }));

        setSubmittedUser(finalRes);
      } else {
        setSubmittedUser([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAllSubUser = async () => {
    try {
      const response = await apiCallFnforGet(GET_ALL_SUB_USER);

      if (response.statusCode === 200) {
        const finalRes = response.data.map((item, i) => ({
          id: i,
          name: item?.name,
          email: item?.email,
          mobile: item?.mobile,
          status: item?.active ? "Enable" : "Disable",
          action: (
            <Select
              value={selectedAction}
              onChange={(e) => {
                setSelectedAction(e.target.value);
                handleAction(item, e.target.value);
              }}
              displayEmpty
              sx={{
                width: 40,
                backgroundColor: "#A3C8ED", // Adjust the color as per your preference
                borderRadius: 8, // Optional: Adds rounded corners for a nicer look
                padding: "8px 2px", // Optional: Adjust padding for better spacing
                height: "25px",
              }}
            >
              <MenuItem value="view">View</MenuItem>
              {hasUserEdit && <MenuItem value="edit">Edit</MenuItem>}
              {hasUserEdit &&
                (item.active ? (
                  <MenuItem value="disable">Disable</MenuItem>
                ) : (
                  <MenuItem value="enable">Enable</MenuItem>
                ))}
            </Select>
          ),
        }));

        setSubmittedUser(finalRes);
      } else {
        setSubmittedUser([]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (type === "Admin") {
      getAllSubUser();
    } else {
      getAll();
    }
  }, [callAgain, prefix]);

  const disableAggregator = async (id, masterMerchantId, action) => {
    const EnableOrDisable = action === "enable" ? "enable" : "disable";

    swal({
      title: "Alert",
      text: `Are you sure, you want to ${EnableOrDisable}`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDisable) => {
      if (willDisable) {
        const formData = new FormData();
        formData.append("id", id);

        apiCallFnforPut(
          `${ENABLE_DISABLE_USER_MANAGEMENT}${action}/${masterMerchantId}/${id}`,
          ""
        )
          .then((res) => {
            if (res.statusCode === 200) {
              swal({
                title: "Success",
                text: `Aggregator ${EnableOrDisable} Successfully.`,
                icon: "success",
              });
              setTimeout(() => {
                if (type === "Admin") {
                  getAllSubUser();
                } else {
                  getAll();
                }
              }, 2000);
              setCallAgain((prevState) => !prevState);
            } else {
              swal({
                title: "Success",
                text: `Failed to ${EnableOrDisable} Aggregator.`,
                icon: "error",
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching data:", error);
          });
      } else {
        // User clicked cancel in the swal confirmation
      }
    });
  };

  const View = (masterMerchantId) => {
    setShow(true);
    setId(masterMerchantId);
  };

  const Edit = (masterMerchantId) => {
    setShow3(true);
    setId(masterMerchantId);
  };

  const handleClose = () => setShow(false);

  const handleClose3 = () => setShow3(false);

  const handleCreateUser = () => setIsModalRoutingOpen(true);
  const handleCloseModalRouting = () => {
    setIsModalRoutingOpen(false);
  };

  return (
    <div class="container-fluid">
      <div className="d-flex justify-content-between bg-white  ">
        <div className="d-flex justify-content-start align-items-center ">
          <button
            type="button"
            class="btn-close m-3"
            onClick={toggleRightBar}
          ></button>

          <div className="fs-2 text-dark fw-bold">Submitted User </div>
        </div>
        {hasUserCreate && (
          <div className="d-flex gap-2 justify-content-end mt-4 me-4">
            <CustomTip size="18" placement="top" title="Create User">
              <div className="" onClick={handleCreateUser}>
                <PersonAddAlt1Icon fontSize="large" />
              </div>
            </CustomTip>
          </div>
        )}
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="col-12">
              <div className="card-body">
                <div style={{ height: "500px", width: "100%" }}>
                  <DataGrid
                    rows={submittedUser}
                    columns={columns?.map((column) => ({
                      ...column,
                      renderCell: (params) =>
                        column.field === "action" ? params.value : params.value,
                    }))}
                    slots={{
                      toolbar: GridToolbar,
                    }}
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ViewUser onHide={handleClose} show={show} UserId={id} />

      <EditUser
        onHide={handleClose3}
        show={show3}
        UserId={id}
        refetch={async () => {
          if (type === "Admin") {
            await getAllSubUser();
          } else {
            await getAll();
          }
          setShow3(false);
        }}
      />

      <Modal
        show={isModalRoutingOpen}
        onHide={handleCloseModalRouting}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fs-4 fw-bold">Create User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateUser
            refetch={async () => {
              if (type === "Admin") {
                await getAllSubUser();
              } else {
                await getAll();
              }
              setIsModalRoutingOpen(false);
            }}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SubmittedUser;
